import {z} from 'zod';
import { ScanRequestTypeSchema } from './scan-request-type';

export const FeatureSchema = z.enum(['deep_scans', 'monitoring']);
export const FeaturesSchema = z.object({
    deep_scans: z.object({
        maxCredits: z.coerce.number()
    }).optional(),
    monitoring: z.object({
        types: z.array(ScanRequestTypeSchema)
    }).optional()
});

export type Feature = z.infer<typeof FeatureSchema>;
export type Features = z.infer<typeof FeaturesSchema>;
